(function() {
  function getThreshold() {
    const country = window.Shopify?.country || 'US';
    return country === 'CA' ? 100 : 75;
  }

  function renderBar(cartTotal) {
    const threshold = getThreshold();
    const thresholdCents = threshold * 100;
    const remaining = thresholdCents - cartTotal;
    const percent = Math.min(100, Math.round((cartTotal / thresholdCents) * 100));
    const unlocked = cartTotal >= thresholdCents;

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    const remainingFormatted = formatter.format(remaining / 100);

    return `
      <div class="lc-free-ship${unlocked ? ' lc-free-ship--unlocked' : ''}" id="lc-shipping-bar">
        <div class="lc-free-ship__text">
          ${unlocked
            ? '<strong>You\'ve unlocked FREE SHIPPING!</strong> 🎉'
            : `You are <strong>${remainingFormatted}</strong> away from <strong>FREE SHIPPING</strong>`
          }
        </div>
        <div class="lc-free-ship__bar">
          <div class="lc-free-ship__fill" style="width: ${percent}%"></div>
        </div>
      </div>
    `;
  }

  function injectBar(cartTotal) {
    const existing = document.getElementById('lc-shipping-bar');
    if (existing) existing.remove();

    const headerTop = document.querySelector('.cart-drawer__header');
    if (!headerTop) return false;

    headerTop.insertAdjacentHTML('afterend', renderBar(cartTotal));
    return true;
  }

  function fetchCartAndInject() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => injectBar(cart.total_price))
      .catch(err => console.error('Free shipping bar error:', err));
  }

  // Watch for cart drawer header to appear in DOM
  const observer = new MutationObserver(function() {
    const headerTop = document.querySelector('.cart-drawer__header');
    if (headerTop && !document.getElementById('lc-shipping-bar')) {
      fetchCartAndInject();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Listen for Horizon cart update events
  document.addEventListener('cart:update', fetchCartAndInject);

  // Run on cart icon click
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      setTimeout(fetchCartAndInject, 500);
    }
  });
})();